var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('iframe',{staticClass:"iframe-sty",style:(_vm.height),attrs:{"src":_vm.srcs}})])
}
var staticRenderFns = []

export { render, staticRenderFns }